export class CommonUtils {
  public static baseLocation(): string {
    return window.location.origin + window.location.pathname + '#';
  }
}
